import { useId, type HTMLAttributes, type ReactNode } from 'react';
import { cx } from './cx';

interface C1SectionProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title?: ReactNode;
  description?: ReactNode;
  /** Trailing control, e.g. a "View all" link. */
  action?: ReactNode;
  children: ReactNode;
}

/** A titled block of page content. */
export function C1Section({
  title,
  description,
  action,
  children,
  className,
  ...props
}: C1SectionProps) {
  const headingId = useId();
  return (
    <section
      className={cx('c1-section', className)}
      aria-labelledby={title ? headingId : undefined}
      {...props}
    >
      {(title || action) && (
        <div className="c1-sectionHeader">
          <div>
            {title ? (
              <h2 className="c1-sectionTitle" id={headingId}>
                {title}
              </h2>
            ) : null}
            {description ? <p className="c1-sectionDescription">{description}</p> : null}
          </div>
          {action}
        </div>
      )}
      {children}
    </section>
  );
}
